<template>
  <iColumn>
    <iText v-if="!activePublicationId">
      Select a publication to start.
    </iText>
    <iColumn v-else>
      <ProfileWrapper
        :splash-image="publicationSplashImage"
        :logo-image="publicationLogo"
        :title="publicationName"
        :details="publicationDescription"
      >
        <template #menu>
          <iLink :href="activePublicationUrl">
            <iButton size="small">
              Edit Publication
            </iButton>
          </iLink>
        </template>
      </ProfileWrapper>
    </iColumn>
  </iColumn>
</template>

<script>
import { mapState } from "pinia";
import { useCreateStore } from "@/stores/create-store";
import ProfileWrapper from "@/components/publication/ProfileWrapper.vue";
import { DEFAULT_ORG_LOGO, DEFAULT_SPLASH_IMAGE } from "%/constants/publication-constants";
import { useGeneralStore } from "%/stores/general-store";

export default {
  name: "PublicationDetails",
  components: { ProfileWrapper },
  props: {
    activePublicationId: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    ...mapState(useCreateStore, [
      "publicationsMap",
    ]),
    activePublication() {
      if (!this.activePublicationId) {
        return {};
      }
      return this.publicationsMap[this.activePublicationId] ?? {};
    },
    activePublicationUrl() {
      return `${useGeneralStore().links.web}/build/${this.activePublicationId}`;
    },
    publicationLogo() {
      return this.activePublication.publication_logo || DEFAULT_ORG_LOGO;
    },
    publicationSplashImage() {
      return this.activePublication.publication_splash_image || DEFAULT_SPLASH_IMAGE;
    },
    publicationName() {
      return this.activePublication.name;
    },
    publicationDescription() {
      return this.activePublication.description ?? "";
    },
  },
};
</script>

<style scoped lang="scss">

</style>
